export default {
  loading: false,
  dialogId: '',
  open: false,
  selectedCard: '',
};
